import { useSearchParams } from 'react-router-dom-latest';
import { adminUrlParams } from 'admin/admin-routes';
import { BrokerUrlParams } from 'broker/broker-routes';

export function useGetParam(param: BrokerUrlParams | adminUrlParams | 'id') {
  const [searchParams] = useSearchParams();
  return searchParams.get(param) ?? '';
}
